export default __webpack_public_path__ + "static/small-image-completely-3-2c38d91ff58785596841263fc23d7491.png";